module.exports = __webpack_public_path__ + "static/media/Bettkissen_80x80_rueckseite.fe2d9ed1.png";